import {Component, computed, inject, OnDestroy, signal} from '@angular/core';
import {BasePageComponent} from "../pages-base/base-page.component";
import {productCardsResourceParams} from "./configs/product-card-page-config";
import {ActivatedRoute} from "@angular/router";
import {ProductCardService} from "./services/product-card.service";
import {defaultProductCardData} from "./configs/default-product-card-data";
import {ProductCardData} from "./types/product-card-data.types";
import {defaultRecordsDataRequestQueryParams} from "../../../core/models/default-records-data-request-query-params";
import {ArticleMarketplaceStateService} from "./services-state/article-marketplace-state.service";
import {
  DynamicService
} from "../../../core/components/records-table/record-table-items/table-selects/services/dynamic.service";
import {
  DynamicSelectStateService
} from "../../../core/components/records-table/record-table-items/table-selects/services/dynamic-select-state.service";
import {
  GetSelectDataParams
} from "../../../core/components/records-table/record-table-items/table-selects/types/dynamic.types";
import {PcHeaderComponent} from "./components/product-card-page-components/pc-header/pc-header.component";
import {PcImagesComponent} from "./components/product-card-page-components/pc-images/pc-images.component";
import {PcTablesComponent} from "./components/product-card-page-components/pc-tables/pc-tables.component";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import { PageInfoComponent } from "../../../core/components/page-info/page-info.component";

@Component({
  selector: 'app-product-card-page',
  imports: [
    PcHeaderComponent,
    PcImagesComponent,
    PcTablesComponent,
    MatIcon,
    MatButton,
    PageInfoComponent
  ],
  templateUrl: './product-card-page.component.html',
  styleUrl: './product-card-page.component.scss'
})
export class ProductCardPageComponent extends BasePageComponent implements OnDestroy {
  private route: ActivatedRoute = inject(ActivatedRoute);
  private productCardService: ProductCardService = inject(ProductCardService);
  private articleMarketplaceStateService: ArticleMarketplaceStateService = inject(ArticleMarketplaceStateService);
  private dynamicService: DynamicService = inject(DynamicService);
  private dynamicSelectStateService: DynamicSelectStateService = inject(DynamicSelectStateService);

  public readonly productCardsResourceParams = productCardsResourceParams;
  public productCardId: number = 0;
  public productCardData: ProductCardData = defaultProductCardData;
  public isProductCardDataLoaded: boolean = false;
  public isVisibleDesc = signal<boolean>(true);
  public iconDesc = computed(() => this.isVisibleDesc() ? 'unfold_less' : 'unfold_more');
  public tooltipBtnDesc = computed(() => this.isVisibleDesc() ? 'Свернуть' : 'Развернуть');

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await this.initPageComponent();
  }

  public ngOnDestroy(): void {
    this.dynamicSelectStateService.resetDynamicState();
  }

  public toggleDesc(): void {
    this.isVisibleDesc.update(i => !i);
  }

  private async initPageComponent(): Promise<void> {
    this.route.params.subscribe(params => this.productCardId = params['id'] || 0);
    if (this.productCardId) {
      await this.getDefaultSelectDataArticle();
      await this.getDefaultSelectDataProduct();
      await this.fetchProductCardSyncData();
      await this.fetchArticleMarketplaces();
    }
  }

  private async fetchProductCardSyncData(): Promise<void> {
    this.productCardData = await this.productCardService.fetchProductCardSyncData(this.productCardId);
    this.isProductCardDataLoaded = true;
  }

  private async fetchArticleMarketplaces(): Promise<void> {
    const queryParams = {
      ...defaultRecordsDataRequestQueryParams,
      size: undefined,
      productCardId: this.productCardId
    };

    await this.articleMarketplaceStateService.setArticleMarketplacesState(queryParams);
  }

  private async getDefaultSelectDataArticle(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = this.dynamicService.getDefaultSelectDataParams(false);
    const selectData = await this.dynamicService.getSelectData(getSelectDataParams);
    this.dynamicSelectStateService.setDynamicState('article', selectData);
  }

  private async getDefaultSelectDataProduct(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = this.dynamicService.getDefaultSelectDataParams(true);
    const selectData = await this.dynamicService.getSelectData(getSelectDataParams);
    this.dynamicSelectStateService.setDynamicState('productId', selectData);
  }
}
